import { LOAD_FEATURE_FLAGS } from "../constants/ActionTypes";

export const loadFeatureFlags = () => ({
  type: LOAD_FEATURE_FLAGS,
  payload: {
    request: {
      url: "feature_flags/",
      method: "GET",
    },
  },
});
